module.exports = __webpack_public_path__ + "static/5-d324529b4d0ef6bd7ee9706590b32099.jpg";